export default function (Component) {
Component.options.__tip = "<p>A button group may only contain <code>FdButtonGroupButton</code>s. If you use <code>FdButton</code> instead, things will not work correctly.</p>\n"
}